export default __webpack_public_path__ + "static/media/settings.e5ff19e1.svg";